import BigCalendar, { BigCalendarType } from "components/Atoms/BigCalendar"
import React from "react"
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop"
import "react-big-calendar/lib/addons/dragAndDrop/styles.css"

type DraggableBigCalendarType = BigCalendarType & {}

const DraggableBigCalendar = ({ ...props }: DraggableBigCalendarType) => {
  return <BigCalendar {...props} />
}

export default withDragAndDrop(DraggableBigCalendar)
